<template>
  <fieldset v-for="survey in surveys" :key="survey.id" class="form-survey">
    <legend>{{ survey.question }}</legend>

    <template v-if="survey.input_type === 'text'">
      <input
        type="text"
        :placeholder="survey.question"
        maxlength="500"
        @input="handleTextInput(survey.id, $event)"
      />
    </template>

    <template v-else-if="survey.input_type === 'checkbox'">
      <label
        v-for="(answer, i) in survey.answers"
        :key="i"
        class="archive__subscribe-form-label"
      >
        <input
          type="checkbox"
          :value="i + 1"
          @change="handleCheckboxInput(survey.id, i + 1, $event)"
        />
        <span>{{ answer }}</span>
      </label>
    </template>

    <template v-else>
      <label
        v-for="(answer, i) in survey.answers"
        :key="i"
        class="archive__subscribe-form-label"
      >
        <input
          type="radio"
          :name="`survey-${survey.id}`"
          :value="i + 1"
          @change="update(survey.id, i + 1, 'radio')"
        />
        <span>{{ answer }}</span>
      </label>
    </template>
  </fieldset>
</template>

<script setup lang="ts">
import type { FormSurvey } from "../lib";

const props = defineProps<{
  surveys: FormSurvey[];
  responses: Record<string, string | number | number[]>;
}>();

const emit = defineEmits<{
  "update:responses": [value: Record<string, string | number | number[]>];
}>();

function update(
  surveyId: string,
  value: string | number,
  inputType: FormSurvey["input_type"],
  checked?: boolean
) {
  const current = { ...props.responses };
  if (inputType === "text") {
    current[surveyId] = value as string;
  } else if (inputType === "checkbox") {
    const existing = (current[surveyId] as number[]) || [];
    current[surveyId] = checked
      ? [...existing, value as number]
      : existing.filter((v) => v !== value);
  } else {
    current[surveyId] = value as number;
  }
  emit("update:responses", current);
}

function handleTextInput(surveyId: string, event: Event) {
  const el = event.target as HTMLInputElement;
  update(surveyId, el.value, "text");
}

function handleCheckboxInput(surveyId: string, index: number, event: Event) {
  const el = event.target as HTMLInputElement;
  update(surveyId, index, "checkbox", el.checked);
}
</script>
